import { Typography, Box, useTheme, IconButton, Menu, MenuItem, Divider } from "@mui/material";
import { tokens, ColorModeContext } from "../theme";
import { useContext, useDebugValue, useEffect, useState } from "react";
import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { ThemeContext } from "../context/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { getUserById, getUsers } from "../redux/slice/users.slice";
import { logout } from "../redux/slice/auth.slice";
import { useNavigate } from "react-router-dom";
import { getuserDashboard } from "../redux/slice/dashboard.slice";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const themeContext = useContext(ThemeContext);
  const UserName = useSelector((state) => state.dashboard.user);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getuserDashboard())
  }, [dispatch])

  const handleTheme = () => {
    themeContext.toggleTheme(themeContext.theme);
  };

  const handleLogout = async () => {
    try {
      const id = localStorage.getItem("id");
      if (id) {
        await dispatch(logout({ id, navigate }));
      }
      localStorage.removeItem("id");
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Box mb="10px" display="flex" className="j_header_block" justifyContent={'space-between'} alignItems={'flex-start'}>
      <Box className="show_space" sx={{ marginLeft: "10px" }}>
        <Typography
          variant="h2"
          className="header-title"
          color={colors.grey[100]}
          fontWeight="bold"
          sx={{ m: "0 0 5px 0" }}
        >
          {title}
        </Typography>
        <Typography className="sub-title" variant="h5" color={colors.greenAccent[400]}>
          {subtitle}
        </Typography>
      </Box>
      <Box className="show_space" display="flex" sx={{ justifyContent: 'flex-end' }}>
        <Box>
          <Typography
            variant="h4"
            color={colors.grey[100]}
            fontWeight="bold"
            sx={{ m: "0 0 5px 0", textWrap: 'nowrap' }}
            className="user_name"
          >
            {UserName?.name}
          </Typography>
          <Typography variant="h6" className="user_email" color={colors.greenAccent[400]}>
            {UserName?.email}
          </Typography>
        </Box>
        <IconButton sx={{ borderRadius: '50%' }} onClick={handleTheme}>
          {theme.palette.mode === "dark" ? (
            <LightModeOutlinedIcon />
          ) : (
            <DarkModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleLogout}
        >
          <LogoutOutlinedIcon />
        </IconButton>
      </Box>
    </Box >
  );
};

export default Header;